import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import {
  IconUsers,
  IconClock,
  IconAlertTriangle,
  IconStar,
  IconCircleX,
} from '@tabler/icons-react';
import { ReferralKpis } from '../../models/referralModel';

interface Props {
  kpis: ReferralKpis;
}

const cardStyle: React.CSSProperties = {
  borderRadius: '10px',
  border: '1px solid #e2e8f0',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.04)',
  backgroundColor: '#ffffff',
  transition: 'all 0.2s ease',
};

const ReferralKpiCards: React.FC<Props> = ({ kpis }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
      }}
    >
      {/* TOTAL REFERIDOS */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Total Referidos
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.total || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#e6f9f3',
                  color: '#00875e',
                }}
              >
                <IconUsers size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* EN GESTIÓN */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                En Gestión
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.in_gestion || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#fff7ed',
                  color: '#ea580c',
                }}
              >
                <IconClock size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* SIN CONTACTAR */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Sin Contactar
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.without_contact || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#ffedd5',
                  color: '#c2410c',
                }}
              >
                <IconAlertTriangle size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* EXITOSOS */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Exitosos
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.successful || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#ede9fe',
                  color: '#5b21b6',
                }}
              >
                <IconStar size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* NO APLICA */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                No Aplica
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.not_apply || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#f1f5f9',
                  color: '#64748b',
                }}
              >
                <IconCircleX size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default ReferralKpiCards;
